import { render, staticRenderFns } from "./PaymentWaiting.vue?vue&type=template&id=f4ba70e0&"
import script from "./PaymentWaiting.vue?vue&type=script&lang=js&"
export * from "./PaymentWaiting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports